// extracted by mini-css-extract-plugin
export default {"rating":"tz-z","numberOfStars":"uz-z","count":"vz-z","barGraphSpacing":"wz-z","barGraph":"xz-z"};